<template>
  <div>
    <div class="pgemnt-3">

      <!-- <div class="func-menu" :style="'height:' + leftHt + 'px' ">
        <div class="item-seek">
          <el-input size="small" placeholder="请输入检索内容" suffix-icon="el-icon-search"></el-input>
        </div>
        <el-tree class="filter-tree" :data="gmTree" :props="defaultProps" node-key="id" :check-strictly="true"
          :current-node-key="defaultAct.id" :highlight-current="true" :default-expanded-keys="defaultArr"
          :filter-node-method="filterNode" @node-click="nodeChange" ref="tree2">
        </el-tree>
      </div> -->

      <div class="role-list" :style="'height:' + leftHt + 'px' ">

        <el-table :data="roleData" style="width: 100%">
          <el-table-column label="序号" width="100" align="center">
            <template slot-scope="scope">
              {{scope.$index+1}}
            </template>
          </el-table-column>
          <el-table-column label="角色名称" width="240" prop="name">
          </el-table-column>
          <el-table-column label="创建日期" width="180" prop="createdAt">
          </el-table-column>
          <el-table-column align="right">
            <template slot="header" slot-scope="scope">
              <el-input class="headSeek" v-model="param.name" size="small" placeholder="输入关键字搜索" />
              <el-button class="newAdd" type="primary" size="mini" @click="roleCtrls('show',1)">新增</el-button>
            </template>
            <template slot-scope="scope">
              <el-button size="mini" @click="roleProwers('show',scope.row)">配置</el-button>
              <el-button size="mini" type="primary" @click="roleCtrls('show',2,scope.row)">修改</el-button>
              <el-button size="mini" type="danger" @click="roleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

      </div>

      <el-dialog :title="roleCreate.diaName" class="pgemnt-3-dag" :visible.sync="roleCreate.diaPop" width="450px"
        center>

        <div class="dagInner">
          <!-- <el-row class="textRow">
            <el-col :span="5">
              <div class="ttName">
                <span>单位名称：</span>
              </div>
            </el-col>
            <el-col :span="18">
              <div class="ttInp">
                <el-input v-model="roleSeek.gmName" size="small" disabled />
              </div>
            </el-col>
          </el-row> -->
          <el-row>
            <el-col :span="5">
              <div class="ttName">
                <span>角色名称：</span>
              </div>
            </el-col>
            <el-col :span="18">
              <div class="ttInp">
                <el-input v-model="roleCreate.roleName" size="small" placeholder="输入角色名称" />
              </div>
            </el-col>
          </el-row>

        </div>

        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="roleCtrls('cencel')">取 消</el-button>
          <el-button type="primary" @click="roleCtrls('sure')" size="small">确 定</el-button>
        </div>

      </el-dialog>

      <el-dialog title="功能配置" :visible.sync="roleConfig.diaPop" width="450px" center>

        <div class="dagInner">
          <el-scrollbar>
            <el-tree :data="roleConfig.treeArr" ref="tree" show-checkbox node-key="id" :check-strictly="true"
              :show-checkbox="true" :default-checked-keys="roleConfig.selected" :props="defaultProps2">
            </el-tree>
          </el-scrollbar>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="roleProwers('cencel')">取 消</el-button>
          <el-button type="primary" @click="roleProwers('sure')" size="small">确 定</el-button>
        </div>

      </el-dialog>
    </div>
  </div>
</template>

<script>
  import {
    getGmTree,
    getRoleList,// 角色列表
    getConfiged,
    CreateRole,// 新增、修改角色
    removeRole,
    ropSave,// 保存角色菜单权限
    ropList,
    dfPower
  } from '@/api/pgMent/roleMent';

  export default {
    data() {
      return {

        leftHt: 0,

        // 机构树
        gmTree: [],


        // 角色表
        roleAllData:[],
        roleData: [],
        roleSeek: {
          where: '',
          gmId: '',
          gmName: '',
        },

        // 角色新建、修改
        roleCreate: {
          diaName: '',
          diaPop: false,
          roleName: '',
          roleId: ''
        },

        // 角色配置
        roleConfig: {
          diaPop: false,
          roleId: '',
          treeArr: [],
          props: {
            children: 'menuRuleModules',
            label: 'name'
          },
          selected: []
        },

        // leftHt:0,
        diaForCet: false,
        diaForSet: false,
        diaTitle: '创建新角色',
        defaultProps: {
          children: 'getCompanyPostModules',
          label: 'name'
        },
        defaultProps2: {
          children: 'menuRuleModules',
          label: 'name'
        },
        roleDat: [],
        data2: [],

        tableData: [],

        search: '',

        diaName1: '',
        diaName2: '',

        // 角色tree默认展开节点

        defaultArr: [],
        defaultAct: '',

        // zym.关键字
        param:{
          name:''
        },

      }
    },
  
    watch: {
      param:{
        deep:true,  //实现深度监听
        handler(v){
          this.filterTableData()
        }
      }
    },

    methods: {
      // 页面数据筛选
      filterTableData:function(){
        let roleData = this.roleAllData;
        let qName = this.param.name;
        // 名称查询
        if(qName){            
          let itemName;
          roleData = roleData.filter(function(item){
            itemName = item.name || '';

            if(itemName.indexOf(qName)>-1){
              return true;
            }
            return false;
          });
        }  

        this.roleData = roleData;
      }
      // 机构树创建
      ,gmTreeCreate: function () {
        // getGmTree().then(response => {
        //   let unFormate = response.getCompanyPostTreeModules;
        //   this.gmTree = unFormate;
        //   this.roleSeek.gmId = unFormate[0].id;
        //   this.roleSeek.gmName = unFormate[0].name;
        //   this.roleSkList();
        //   // this.defaultAct = unFormate[0];
        //   // this.getLists();
        // }).catch(error => {
        //   console.log(error);
        // })

        this.roleSkList();
      },

      // 机构切换

      nodeChange: function (node, state) {
        if (node.id != this.roleSeek.gmId) {
          this.roleSeek.gmId = node.id;
          this.roleSeek.gmName = node.name;
          this.roleSkList();
        }
      },

      // 关联机构的角色列表
      roleSkList: function () {
        getRoleList({
          id: this.roleSeek.gmId,
          type: 4
        }).then(response => {
          // console.log('response=',JSON.stringify(response));
          // let unFormate = response.getCompanyPostModules;
          // this.roleData = unFormate;
          this.roleAllData = response.payload;
          this.filterTableData();
        }).catch(error => {
          console.log(error);
        })
      },

      // 角色新建、修改
      roleCtrls: function (type, code, dats) {
        if (type == 'show') {
          if (code == 1) {
            this.diaName = '新建角色';
            this.roleCreate.roleName = '';
            this.roleCreate.roleId = '';
          } else if (code == 2) {
            this.diaName = '修改角色信息';
            this.roleCreate.roleName = dats.name;
            this.roleCreate.roleId = dats.id;
          }
          this.roleCreate.diaPop = true;
        } else if (type == 'cencel') {
          this.roleCreate.diaPop = false;
        } else if (type == 'sure') {
          CreateRole({
            post: {
              id: this.roleCreate.roleId,
              name: this.roleCreate.roleName,
              companyOrganizationId: this.roleSeek.gmId,
            }
          }).then(response => {
            let tipCode = response.tipCode;
            let tipMessage = response.message || '操作失败';
            if(tipCode=='fail'){
              this.$message({
                showClose: true,
                message: tipMessage,
                type: 'error'
              })
            }
            else{
              this.$message({
                message: '操作成功！',
                type: 'success'
              })
              this.roleCreate.diaPop = false;
              this.roleSkList();
            }
          }).catch(error => {
            this.$message({
              message: '创建失败，请稍后重试！',
              type: 'error'
            })
          })
        }
      },
      // 角色删除
      roleDelete: function (dats) {
        this.$confirm("删除后无法恢复，是否确定删除！",'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          removeRole({
            id: dats.id,
            type: 4
          }).then(response => {
            let tipCode = response.tipCode;
            let tipMessage = response.message || '操作失败';
            if(tipCode=='fail'){
              this.$message({
                showClose: true,
                message: tipMessage,
                type: 'error'
              })
            }
            else{
              this.$message({
                message: '操作成功！',
                type: 'success'
              })
              this.roleSkList();
            }
          }).catch(error => {
            this.$message({
              message: '删除失败，请稍后重试！',
              type: 'error'
            })
          })
        }).catch(() => {});        
      },
      // zym.生成树形结构
      arrayToTree(nodes, config) {
          if (!Array.isArray(nodes)) {
              console.error('params arr need Array');
              return [];
          }

          // let cfg = Object.assign(config, {id: 'id', pid: 'pid', sn: 'level', order: true});
          let cfg = Object.assign({id: 'id', pid: 'pid', sn: 'level', order: true},config);
          // console.log('cfg=',JSON.stringify(cfg));
          let keyName = cfg.id;
          let parentKeyName = cfg.pid;
          let sn = cfg.sn;
          let order = cfg.order;
          
          let map = {};
          nodes.forEach(v => {
              if(!v[parentKeyName]){
                v[parentKeyName] = "0";
              }
              v.menuRuleModules = [];
              map[v[keyName]] = v;
          });
          // console.log("nodes=",JSON.stringify(nodes));
          map[0] = {[keyName]: "0", name: 'root', menuRuleModules: []};
          nodes.forEach(v => {
            // console.log('map[v[parentKeyName]]=',v[parentKeyName]);
            if(v[parentKeyName]){
              let menuRuleModules = map[v[parentKeyName]].menuRuleModules;

              // 当前第一个节点，直接放入children数组
              if (menuRuleModules.length == 0) {
                  menuRuleModules.push(v);
                  return true;
              }
              
              // 序号小的节点排在前面，否则往后放
              if (order) {
                  let i = 0;
                  for (let len = menuRuleModules.length; i < len; i++) {
                      if (v[sn] < menuRuleModules[i][sn]) {
                          break;
                      }
                  }
                  menuRuleModules.splice(i, 0, v);
              } else {
                  menuRuleModules.push(v);
              }
            }
          });
          return map[0].menuRuleModules;
      },
      // 角色权限
      roleProwers: function (type, dats) {
        function arrsCreate(dats, arrs) {
          for (let i = 0; i < dats.length; i++) {
            arrs.push(dats[i].id);
            if (dats[i].menuRuleModules.length > 0) {
              arrsCreate(dats[i].menuRuleModules, arrs);
            }
          };
          return arrs;
        }

        if (type == 'show') {
          this.roleConfig.diaPop = true;
          this.roleConfig.roleId = dats.id;

          // 把数据重置
          this.roleConfig.treeArr = [];
          this.roleConfig.selected = [];

          ropList({
            postId: this.roleSeek.gmId
          }).then(response => {
            // console.log('menuTree=',JSON.stringify(response.payload))
            let menuTree = this.arrayToTree(response.payload,{"id":"id","pid":"pId","sn" : "createdAt"})
            // console.log('menuTree=',JSON.stringify(menuTree))
            this.roleConfig.treeArr = menuTree;// response.payload;// menuRuleTreeModules;
          });

          // 查询角色的菜单权限
          dfPower({
            postIds: [dats.id]
          }).then(response => {
            console.log('response=',response.menuRuleTreeModules);
            // this.roleConfig.selected = arrsCreate(response.menuRuleTreeModules, []);
            this.roleConfig.selected = response.menuRuleTreeModules.map((item)=>{
              return item.id;
            })
          })
        } 
        // 取消页面弹窗
        else if (type == 'cencel') {
          this.roleConfig.diaPop = false;
        } 
        // 保存角色的菜单设置
        else if (type == 'sure') {         
          ropSave({
            postId: this.roleConfig.roleId,
            menuIds: this.$refs.tree.getCheckedKeys()
          }).then(response => {
            let tipCode = response.tipCode;
            let tipMessage = response.message || '操作失败';
            if(tipCode=='fail'){
              this.$message({
                showClose: true,
                message: tipMessage,
                type: 'error'
              })
            }
            else{
              this.$message({
                message: '操作成功！',
                type: 'success'
              });
              this.roleConfig.diaPop = false;
            }
          }).catch(error => {
            this.$message({
              message: '保存失败，请稍后重试！',
              type: 'error'
            })
          })
        }
      },

      filterNode: function (value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },


    },

    beforeMount: function () {
      this.leftHt = window.screen.height - 285;
    },

    created: function () {
      this.gmTreeCreate();
    }
  }
</script>

<style lang="scss">
  .pgemnt-3 {
    padding-left: 1px;
    position: relative;
    /*padding: 20px 30px;*/
  }

  /* 角色树 */

  .pgemnt-3 .func-menu {
    width: 240px;
    border-right: 1px solid #ebeef5;
    position: absolute;
    left: 1px;
    top: 0px;
  }


  .pgemnt-3 .filter-tree {
    margin: 12px 6px;
  }

  .pgemnt-3 .item-seek {
    padding: 15px 9px;
    border-bottom: 1px solid #ebeef5;
  }

  .pgemnt-3 .el-tree-node .el-tree-node__content {
    padding: 3px 0px 5px;
  }


  /* 角色列表 */
  /* margin-left: 280px;*/
  .pgemnt-3 .role-list {
    border-left: 1px solid #ebeef5;
    padding: 0px 20px;
    position: relative;
  }

  .pgemnt-3 .role-list .headSeek {
    width: 360px;
    vertical-align: middle;
    display: inline-block;
  }

  .pgemnt-3 .role-list .newAdd {
    width: 90px;
    vertical-align: middle;
    display: inline-block;
  }



  /* 创建弹出层 */

  .pgemnt-3-dag .btncage {
    text-align: center;
  }

  .pgemnt-3-dag .el-button {
    /*width: 90px;*/
  }

  .pgemnt-3-dag .dialog-footer {
    margin-bottom: 5px;
  }

  .pgemnt-3-dag .textRow {
    margin-bottom: 24px;
  }

  .pgemnt-3-dag .ttName {
    text-align: right;
    line-height: 26px;
  }

  .pgemnt-3-dag .ttName span {
    margin-right: 12px;
    vertical-align: middle;
  }

  .pgemnt-3 .dagInner .el-scrollbar__wrap {
    max-height: 360px;
    padding: 0px 0px 12px;
    overflow-x: hidden;
  }
</style>



// WEBPACK FOOTER //
// roleMent.vue?b7117ff2